import React from 'react';
import { Box, Heading } from '@hover/blueprint';
import { iMapPin, iUsers } from '@hover/icons';
import JobPostBadge from '../JobPostBadge';

interface Props {
  jobTitle: string;
  office: string;
  department: string;
}

const FormHeader: React.FC<Props> = ({ jobTitle, office, department }) => (
  <Box flexDir="column">
    <Heading size={500} marginBottom={{ base: 500, tablet: 600 }} isLight>
      Apply for:{' '}
      <Heading size={500} marginBottom={0} isDisplay as="span">
        {jobTitle}
      </Heading>
    </Heading>
    <Box mb={900}>
      <JobPostBadge mr={600} bg="neutral.100" icon={iMapPin} title={office} />
      <JobPostBadge bg="neutral.100" icon={iUsers} title={department} />
    </Box>
  </Box>
);

export default FormHeader;
